import { useContext } from "react";
import { useSelector } from "react-redux";

import { CompanyContext } from "../../../components/CompanyList/CompanyContext";
import { getAwardText } from "../../../selectors";
import { BaseBenefitsColumns } from "../../BaseComponents/BaseBenefitsColumns";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "../../BaseComponents/BaseCompanyName";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "../../BaseComponents/BaseProductDescription";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseSoftwareRating } from "../../BaseComponents/BaseSoftwareRating";
import { BaseTrustpilotReview } from "../../BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { getStyles } from "./styles";
import {
	DEFAULT_LINK_TEXT,
	ThemeContext,
	TRUSTPILOT_REVIEW_WIDGET,
	WEB_REVIEW_WIDGET,
} from "./ThemeContext";

export const FavySoftwareLayout = () => {
	const { linkText = DEFAULT_LINK_TEXT, hasReviewWidget = false } =
		useContext(ThemeContext);

	const { company } = useContext(CompanyContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));

	const styles = getStyles();

	return (
		<div className="tw-mb-5 tw-block tw-overflow-hidden tw-rounded-lg tw-bg-white tw-shadow-[0px_1px_2px_0px_rgba(88,102,126,0.12),_0px_4px_24px_0px_rgba(88,102,126,0.06)]">
			<div className="tw-flex tw-min-h-[250px] tw-flex-col tw-items-center tw-justify-center tw-py-6 lg:tw-flex-row lg:tw-items-stretch lg:tw-justify-start">
				{/* Column 1 */}
				<div
					className={`tw-relative tw-flex tw-w-full tw-max-w-none tw-flex-col tw-justify-center lg:tw-w-[25%] ${awardText ? "tw-pt-6 lg:tw-pt-0" : ""}`}
				>
					<BaseLinkWrapper>
						<BaseServiceFlag classNames={styles.serviceFlag} />
						<div className="tw-flex tw-justify-evenly">
							<BaseCompanyLogo classNames={styles.companyLogo} />
							{hasReviewWidget && (
								<div className="tw-flex tw-items-center tw-justify-center lg:tw-hidden">
									{hasReviewWidget === TRUSTPILOT_REVIEW_WIDGET && (
										<BaseTrustpilotReview
											classNames={styles.trustpilotReview}
										/>
									)}
									{hasReviewWidget === WEB_REVIEW_WIDGET && (
										<BaseSoftwareRating classNames={styles.rating} />
									)}
								</div>
							)}
						</div>
					</BaseLinkWrapper>
				</div>
				{/* Column 2 */}
				<div className="tw-my-2 tw-flex tw-w-[90%] tw-max-w-none tw-flex-col tw-items-start tw-justify-center tw-px-0 lg:tw-my-0 lg:tw-w-[53%]">
					<BaseLinkWrapper>
						<div>
							<BaseCompanyName className="tw-mb-6 tw-text-2xl tw-font-bold tw-leading-6 tw-text-[#000a25]" />
							<BaseProductDescription className="tw-font-base tw-mb-6 tw-leading-6 tw-text-[#000a25]" />
						</div>
						<div>
							<BaseBenefitsColumns classNames={styles.benefitsList} />
						</div>
					</BaseLinkWrapper>
				</div>
				{/* Column 3 */}
				<BaseLinkWrapper className="tw-flex tw-w-full tw-max-w-none tw-flex-row tw-flex-wrap tw-items-center tw-justify-evenly tw-gap-4 lg:tw-flex-1 lg:tw-flex-col lg:tw-justify-center lg:tw-px-4">
					<BaseVisitLink {...styles.visitLink}>{linkText}</BaseVisitLink>
					<div className="tw-hidden lg:tw-block">
						{hasReviewWidget === TRUSTPILOT_REVIEW_WIDGET && (
							<BaseTrustpilotReview classNames={styles.trustpilotReview} />
						)}
						{hasReviewWidget === WEB_REVIEW_WIDGET && (
							<BaseSoftwareRating classNames={styles.rating} />
						)}
					</div>
				</BaseLinkWrapper>
			</div>
		</div>
	);
};
